import { Helmet } from "react-helmet"

interface CommonPixelProps {
    pixelId?: string|null;
}

export enum Tracker {
    SIGNUP = `signup`,
    DISCOVER = `discover`,
    FUMBLE = `fumble`
}

const CommonPixel = (props: CommonPixelProps) => {
    const { pixelId } = props

    if (pixelId === Tracker.SIGNUP) {
        return (
            <Helmet>

            </Helmet>
        )
    }
    return (
        <>
        </>
    )
}

export default CommonPixel